<template>
  <v-card>
    <v-card-text>
      <v-alert type="error" v-if="error">
        {{ error }}
      </v-alert>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-row v-if="!loading">
          <v-col cols="3">
            <shop-select
              v-model="model.shopId"
              :rules="[rules.notHeadOnlyRequired]"
            ></shop-select>
          </v-col>
          <v-col cols="3">
            <customer-autocomplete
              v-model="model.clientId"
              :rules="[rules.notHeadOnlyRequired]"
            ></customer-autocomplete>
          </v-col>
          <v-col cols="3">
            <location-autocomplete
              v-model="model.locationId"
              :disabled="isDisabled"
              :rules="[rules.notHeadOnlyRequired]"
            ></location-autocomplete>
          </v-col>
          <v-col cols="3" class="d-flex">
            <shipping-select
              :locationId="model.locationId"
              v-model="model.shipping_id"
              :disabled="isDisabled || !!model.pickup"
              :rules="!model.pickup ? [rules.notHeadOnlyRequired]: []"
            ></shipping-select>
            <v-btn small class="ml-2 mt-4" outlined color="warning" @click="pickup">Switch to<br/>{{model.pickup ? 'Delivery' : 'Pick Up'}}</v-btn>
          </v-col>
          <v-col cols="3">
            <currency-select
              v-model="model.currencyId"
              :disabled="isDisabled"
              :rules="[rules.notHeadOnlyRequired]"
            ></currency-select>
          </v-col>
          <v-col cols="3">
            <tax-rate-autocomplete
              v-model="model.taxRateId"
              label="Tax Rate"
              :disabled="isDisabled"
              :rules="[rules.notHeadOnlyRequired]"
              :locationId="model.locationId"
            ></tax-rate-autocomplete>
          </v-col>
          <v-col cols="3">
            <fitter-select v-model="model.clubFitterId"
              :rules="[rules.notHeadOnlyRequired]"
            ></fitter-select>
          </v-col>
          <v-col cols="3">
            <v-text-field
              v-model.lazy="model.clientPo"
              label="Client's PO"
              hint="To filled only if client have a PO number"
              @change="update"
              clearable
            />
          </v-col>
        </v-row>

        <v-row v-else align-center justify-center column fill-height>
          <v-progress-circular :size="70" :width="7" indeterminate color="error"></v-progress-circular>
        </v-row>
        <ConfirmBox ref="confirm" />

        
      </v-form>
    </v-card-text>
    <v-card-actions v-if="isNew">
      <v-spacer></v-spacer>
      <v-btn color="accent" @click="create">Create</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import CustomerAutocomplete from "@components/forms/autocomplete/Customer.vue";
import LocationAutocomplete from "@components/forms/autocomplete/Location.vue";
import ShippingSelect from "@components/forms/select/Shipping.vue";
import CurrencySelect from "@components/forms/select/Currency.vue";
import ShopSelect from "@components/forms/select/Shop.vue";
import FitterSelect from "@components/forms/select/Fitter.vue";
import TaxRateAutocomplete from "../../components/forms/autocomplete/TaxRate.vue"
import ConfirmBox from "../ui/ConfirmBox.vue";
export default {
  components: {
    CustomerAutocomplete,
    LocationAutocomplete,
    ShippingSelect,
    CurrencySelect,
    TaxRateAutocomplete,
    ShopSelect,
    FitterSelect,
    ConfirmBox
  },
  props: ["order"],
  data() {
    return {
      loading: false,
      valid: false,
      model: this.order ? this.order : {},
      error: null
    };
  },
  methods: {
    update: function() {
      if (!this.isNew && this.$refs.form.validate()) {
        this.loading = true;
        this.error = null
        let tmpObject = Object.assign({}, this.model);
        delete tmpObject.created_at;
        this.$store
          .dispatch("orders/update", {
            orderId: this.model.id,
            model: tmpObject
          })
          .then(result => {
            Object.assign(this.$data.model, result);
            this.$emit("orderUpdate", result);
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    create: function() {
      if (this.isNew && this.$refs.form.validate()) {
        this.loading = true;
        this.error = null
        this.$store
          .dispatch("orders/create", {
            model: this.model
          })
          .then(result => {
            Object.assign(this.$data.model, result);
            this.$emit("orderCreate", result);
          })
          .catch(({data}) => {
            this.error = data.message
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    async pickup () {
      if(this.model.pickup){
        if(await this.$refs.confirm.open("Switch the shipping mode into Delivery ?", "In 'Delivery' mode, an order need manual process by the Shop")){
          this.model.pickup = false
        }
      }else {
        if(await this.$refs.confirm.open("Switch the shipping mode into Pickup ?", "In 'Pick up' mode, an order are directly picked by customer, no build required")){
          this.model.pickup = true
          this.model.shipping_id = "3"
        }
      }
    }
  },

  computed: {
    isDisabled: function() {
      if (this.order && this.order.statusId != "new") return true;
      return false;
    },
    isNew: function() {
      if (this.order) return false;
      return true;
    },
    rules: function() {
      return {
        required: value => !!value || "This field is mandatory.",
        notHeadOnlyRequired: value => {
          if (this.model.headOnly) return true;
          return !!value || "This field is mandatory.";
        }
      };
    }
  },
  watch: {
    order: function() {
      this.model = this.order;
    },
    model: {
      deep: true,
      handler () {
        this.update()
      }
    }
  }
};
</script>

<style></style>
